<template>
  <div class="user-visits-page">
    <img src="../assets/face logo.png">

    <div class="title">
      Face Club COVID-19 Tracking
    </div>

    <div class="visits-stats">
      <div class="sector-visits-stats">
        <div class="sector-title">TOTAL:</div>
        <div class="sector-number">{{totalVisits}}</div>
      </div>
      <div class="sector-visits-stats" v-for="userVisitsPerSector in userVisitsPerSectors">
        <div class="sector-title" :class="{[userVisitsPerSector.sector] : true}">{{userVisitsPerSector.sector}}:</div>
        <div class="sector-number">{{userVisitsPerSector.total}}</div>
      </div>
    </div>

    <div class="subtitle">
      Registrierungsliste
    </div>


    <div class="fc-form">
      <div class="fc-form-row">
        <input
          type="text"
          placeholder="Vor- oder Nachname.."
          v-debounce:300="searchLatestUserVisits" v-model="search"/>
      </div>
    </div>

    <user-visits-list
      :user-visits="userVisits"
      @updateUserSector="updateUserSector"
    />
  </div>
</template>

<script>
  import {
    listLatestUserVisits,
    updateUserVisitSector,
    getNumberLatestUserVisitsBySector,

  } from "../services/graphql";
  import UserVisitsList from "../components/UserVisitsList";

  export default {
    name: "UserVisitsPage",
    components: {UserVisitsList},
    data() {
      return {
        userVisits: [],
        search: null,
        isLoading: true,
        userVisitsPerSectors: {},
        totalVisits: null,
        pagination: {
          rowsPerPage: 20,
          page: 1
        }
      };
    },

    methods: {
      updateUserSector(data) {
        updateUserVisitSector(data).then(userVisit => {
          this.userVisits = this.userVisits.map(uv =>
            uv.id !== userVisit.id ? uv : userVisit
          );
          this.getNumberLatestUserVisitsBySector()
        });
      },
      searchLatestUserVisits(search) {

        this.pagination = {
          ...this.pagination,
          page: 1
        };
        this.filterLatestUserVisits(search)
      },

      filterLatestUserVisits(search) {
        return listLatestUserVisits({
          pagination: this.pagination,
          search
        }).then(({result, pagination}) => {
          this.userVisits = result;
        });
      },
      getNumberLatestUserVisitsBySector() {
        return getNumberLatestUserVisitsBySector()
          .then(({rez, total}) => {
              this.userVisitsPerSectors = rez;
              this.totalVisits = total;
            }
          )
      }
    },
    created() {
      let code = prompt("Please enter access code");
      if (code === ';>X8$J2y?ytQSF2=') {
        this.filterLatestUserVisits();
        this.getNumberLatestUserVisitsBySector();
      } else {
        this.$router.push({
          name: "HomePage"
        })
      }
    }
  };
</script>

<style lang="scss">
  @import "UserVisitsPage";
</style>
